import { createContext, useContext } from 'react';

// Âmbito de ativo para os widgets do dashboard.
// - No painel principal o valor é `undefined` → widgets agregam a frota (comportamento atual).
// - No detalhe do ativo o valor é o `vehicleId` → cada widget junta-o à sua criteria,
//   mantendo o seu próprio seletor de período (igual ao painel principal, só com o ativo "a mais").
export const DashboardVehicleScopeContext = createContext<string | undefined>(undefined);

export const useDashboardVehicleScope = () => useContext(DashboardVehicleScopeContext);

// Helper para juntar (ou não) o vehicleId de âmbito a uma criteria, sem enviar a chave quando não há âmbito.
export const vehicleScopeCriteria = (scopeVehicleId?: string) =>
	(scopeVehicleId ? { vehicleId: scopeVehicleId } : {}) as { vehicleId?: string };
